import { BubbleError, AuthMainLayout } from '@/components';
import { forgotPassword } from '@/features/authentication/features/forgot-password/routes';
import { loginRoute } from '@/features/authentication/features/login';
import { otpRoute } from '@/features/authentication/features/otp';
import { Navigate, RouteObject } from 'react-router-dom';

export const authRoute: RouteObject = {
  element: <AuthMainLayout />,
  children: [
    {
      index: true,
      element: <Navigate to="/login" />,
    },
    loginRoute,
    ...forgotPassword,
    otpRoute,
    {
      path: '*',
      element: <Navigate to=".." />,
    },
  ],
  errorElement: <BubbleError />,
};
